import { DefaultError, QueryClient, QueryKey, useQuery, UseQueryOptions, UseQueryResult } from "@tanstack/react-query";
import axios from "axios";
import { useLocalStorage } from "~/Hooks/useLocalStorage";
import { centralizedHost } from "~/Utils";

export interface DocumentDetailsResponse {
  id: string;
  image: string;
  name: string;
  name_ms: string;
  name_zh: string;
  description: string;
  description_ms: string;
  description_zh: string;
  airport: string[];
  link: string;
  published: string;
  banner_image: string;
  project_airport_id: any;
}

export interface DocumentDetailsResponseHeading {
  id: string;
  title: string;
  field_page_banner_image: string;
  field_page_title_en: string;
  field_page_title_ms: string;
  field_page_title_zh: string;
  field_page_description_en: string;
  field_page_description_ms: string;
  field_page_description_zh: string;
}

const fetchLandingHeadingDetails = async (airport: string | null): Promise<DocumentDetailsResponseHeading> => {
  if (!airport) throw new Error("Airport not found");
  const response = await axios.get(
    `${centralizedHost}api/page-headers/all-fields?pageName=shop-dine-services/services&airport=${airport}`
  );
  return response.data[0];
};

const useLandingHeadingDocumentDetails = (
  id: string,
  options?: UseQueryOptions<DocumentDetailsResponseHeading, DefaultError>,
  queryClient?: QueryClient
): UseQueryResult<DocumentDetailsResponseHeading, DefaultError> => {
  const [currentAirport] = useLocalStorage("currentAirport", null);
  return useQuery<DocumentDetailsResponseHeading, DefaultError>(
    {
      queryKey: ["FlightHeadingDocumentDetails", id, currentAirport],
      enabled: !!id && !!currentAirport,
      queryFn: () => fetchLandingHeadingDetails(currentAirport),
      refetchOnWindowFocus: false,
      ...options,
    },
    queryClient
  );
};

// edit api call
const fetchLandingPageContentDetails = async (id: string): Promise<any> => {
  if (!id) {
    return null;
  }
  const response: any = await axios.get(`${centralizedHost}api/shop-category-type-child/${id}`);

  return response?.data[0];
};

const useLandingPageContenDocumentDetails = (
  id: string,
  options?: UseQueryOptions<DocumentDetailsResponse, DefaultError, DocumentDetailsResponse, QueryKey>,
  queryClient?: QueryClient
): UseQueryResult<DocumentDetailsResponse, DefaultError> => {
  return useQuery<DocumentDetailsResponse, DefaultError, DocumentDetailsResponse, QueryKey>(
    {
      queryKey: ["landingPageContenDetails", id],
      enabled: false,
      queryFn: () => {
        return fetchLandingPageContentDetails(id);
      },
      refetchOnWindowFocus: false,
      ...options,
    },
    queryClient
  );
};

export { useLandingHeadingDocumentDetails, useLandingPageContenDocumentDetails };
